<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Form ref="formValidate" :model="formValidate" :label-width="110">
        <Row>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商名称:" prop="agentName">
              <Input v-model.trim="formValidate.agentName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商订单号:" prop="outTradeNo">
              <Input v-model.trim="formValidate.outTradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="平台订单号:" prop="tradeNo">
              <Input v-model.trim="formValidate.tradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="充值状态:" prop="nodeState">
              <Select v-model="formValidate.nodeState" clearable style="width: 100%;">
                <Option v-for="item in rechargeStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="充值方式:" prop="rechargeType">
              <Select v-model="formValidate.rechargeType" clearable style="width: 100%;">
                <Option v-for="item in rechargeType" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品编号:" prop="commodityId">
              <Input v-model.trim="formValidate.commodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="充值账号:" prop="account">
              <Input v-model.trim="formValidate.account" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="开始时间:" prop="startDate">
              <DatePicker type="datetime" v-model="formValidate.startDate" placeholder="请选择" style="width:100%" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="结束时间:" prop="endDate">
              <DatePicker type="datetime" v-model="formValidate.endDate" placeholder="请选择" style="width:100%" />
            </FormItem>
          </Col>
          <Col :md='24' class="text-right">
            <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
            <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col :md='24' style="margin-bottom: 20px">
          <Button
            type="info"
            icon="md-download"
            style="margin-right: 8px"
            :disabled="!queryData.length"
            @click="exportOrder"
          >导出</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{row}" slot="nodeState">
          <RechargeStatus :node-state="row.nodeState" />
        </template>
        <template slot-scope="{row}" slot="action">
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-eye"
            @click="detailItem(row)"
          >详情</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <RechargeDetail ref="rechargeDetail" />
    <ExportFile ref="exportFile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import utils from '../../utils'
import RechargeStatus from '../../components/order/RechargeStatus'
import RechargeDetail from '../../components/order/RechargeDetail'
import ExportFile from '../../components/common/ExportFile'

export default {
  components: {
    RechargeStatus,
    RechargeDetail,
    ExportFile
  },
  data () {
    return {
      formValidate: {
        agentId: null,
        outTradeNo: null,
        tradeNo: null,
        nodeState: null,
        rechargeType: null,
        commodityId: null,
        account: null,
        startDate: null,
        endDate: null
      },
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1
    }
  },
  computed: {
    startDate () {
      return this.formValidate.startDate ? this.formValidate.startDate.getTime() : null
    },
    endDate () {
      return this.formValidate.endDate ? this.formValidate.endDate.getTime() : null
    },
    startDateText () {
      return this.startDate ? utils.formatDateTime(this.startDate) : null
    },
    endDateText () {
      return this.endDate ? utils.formatDateTime(this.endDate) : null
    },
    ...mapGetters('recharge', ['rechargeStatus', 'rechargeType']),
    queryColumn () {
      return [
        {
          title: '平台订单号',
          key: 'tradeNo',
          minWidth: 150
        },
        {
          title: '代理商订单号',
          key: 'outTradeNo',
          minWidth: 150
        },
        {
          title: '代理商名称',
          key: 'agentName',
          minWidth: 150
        },
        {
          title: '商品名称',
          key: 'commodityName',
          minWidth: 150
        },
        {
          title: '商品编号',
          key: 'commodityId',
          minWidth: 150
        },
        {
          title: '商品单价（元）',
          key: 'facePrice',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '充值账号',
          key: 'account',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createDate',
          minWidth: 190,
          render: (h, params) => {
            return h('span', utils.formatDateTime(params.row.createDate))
          }
        },
        {
          title: '充值状态',
          key: 'nodeState',
          minWidth: 120,
          slot: 'nodeState',
          align: 'center'
        },
        {
          title: '失败原因',
          key: 'rechargeBack',
          minWidth: 190,
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 100,
          slot: 'action',
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    formSubmit () {
      // 判断开始时间和结束时间
      if (this.startDate && this.endDate && (this.startDate >= this.endDate)) {
        this.$Message.error('开始时间不能大于或等于结束时间！')
        return
      } else if (this.startDate && !this.endDate) {
        this.$Message.error('请选择结束时间！')
        return
      } else if (!this.startDate && this.endDate) {
        this.$Message.error('请选择开始时间！')
        return
      }
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset () {
      this.$refs['formValidate'].resetFields()
      this.formSubmit()
    },
    filterCkeck (item) {
      return item
    },
    getData () {
      this.loading = true
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          const element = this.formValidate[item]
          if (element !== '' && element !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = this.pageSize
      if (this.startDate) {
        params.startDate = this.startDate
      }
      if (this.endDate) {
        params.endDate = this.endDate
      }
      api.order.rechargeList({
        ...params
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 详情
    detailItem (row) {
      this.$refs.rechargeDetail.show(row)
    },
    // 导出
    exportOrder () {
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          if (this.formValidate[item] !== '' && this.formValidate[item] !== null) {
            if (item === 'startDate' || item === 'endDate') {
              params[item] = new Date(this.formValidate[item]).getTime()
            } else {
              params[item] = this.formValidate[item]
            }
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = 100
      this.$refs.exportFile.submit(api.order.outQueryOrder, 'get', {
        ...params
      })
    }
  },
  created () {
    this.getData()
  }
}
</script>
